import { ExpandMore } from '@mui/icons-material';
import { Typography, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

export const WarrantyFaq = () => {
  return (
    <>
      <Typography variant="h2" align="center">
        FAQ
      </Typography>
      <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
        {faqs.map((faq, index) => {
          return (
            <Accordion key={faq.question}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {index === 1 && (
                    <Typography component="span" sx={{ fontStyle: 'italic' }}>
                      Our top priority is your safety.{' '}
                    </Typography>
                  )}
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </>
  );
};

const faqs = [
  {
    question: 'How long does the warranty process take?',
    answer:
      'The length of the warranty process can vary depending on the issue, but our team works as quickly as possible to address your needs. Once your claim is submitted, we’ll review it promptly and reach out to guide you through the next steps. Rest assured, we’re here to support you every step of the way.'
  },
  {
    question: 'What should I do in case of an emergency repair?',
    answer:
      'For an emergency repair, please reference your breaker box and the emergency contacts for each trade. If necessary, remember to shut off the power or water to your home to prevent further damage. Please submit a claim in Buildertrend, and our team will contact you quickly to guide you through the next steps.'
  }
];
